import React, { useState } from 'react';
import {
  Button,
  IconPencilFilled,
  IconTrashFilled,
} from 'takeat-design-system-ui-kit';
import toast from 'react-hot-toast';
import api from '~/services/api';
import { useAuth } from '~/context/AuthContext';
import { PrinterModal } from '../PrinterModal';
import { PrinterModalDelete } from '../printerModalDelete';
import { ActionButtonsContainer, TableCell, TableRow } from './styles';

const PrinterRow = ({ printer, onDelete, onUpdate }) => {
  const { user, logout } = useAuth();
  const [isDeleting, setIsDeleting] = useState(false);
  const [editModalOpen, setEditModalOpen] = useState(false);
  const [editDeleteOpen, setEditDeleteOpen] = useState(false);
  const [printerNames, setPrinterNames] = useState([]);
  const [printerNamesLoading, setPrinterNamesLoading] = useState(false);

  const handleEdit = async () => {
    setEditModalOpen(true);
  };

  const handleDelete = async () => {
    setEditDeleteOpen(true);
  };

  const handleModalClose = () => {
    setEditModalOpen(false);
    setEditDeleteOpen(false);
  };

  return (
    <>
      <TableRow>
        <TableCell>{printer.name}</TableCell>
        <TableCell>{printer.host}</TableCell>
        <TableCell>
          <p>{printer.print_bills_allowed && 'Comandas'}</p>
          <p>{printer.print_orders_allowed && 'Pedidos'}</p>
          {/* <p>{printer.print_reports_allowed && 'Relatórios'}</p> */}
        </TableCell>
        <TableCell>-</TableCell>
        <TableCell>
          <ActionButtonsContainer
            style={{
              display: 'flex',
              gap: '8px',
              justifyContent: 'center',
              alignItems: 'center',
            }}
          >
            <Button
              variant="outlined"
              style={{
                height: 32,
                width: 32,
                backgroundColor: '#fff',
              }}
              onClick={handleEdit}
            >
              <IconPencilFilled />
            </Button>
            <Button
              variant="outlined"
              style={{
                height: 32,
                width: 32,
                backgroundColor: '#fff',
              }}
              onClick={handleDelete}
              disabled={isDeleting}
              isLoading={isDeleting}
            >
              <IconTrashFilled />
            </Button>
          </ActionButtonsContainer>
        </TableCell>
      </TableRow>

      {editModalOpen && (
        <PrinterModal
          open={editModalOpen}
          onClose={handleModalClose}
          printerNames={printerNames}
          printerNamesLoading={printerNamesLoading}
          isEdit
          printerData={printer}
          onPrinterUpdate={onUpdate}
        />
      )}
      <PrinterModalDelete
        open={editDeleteOpen}
        onClose={handleModalClose}
        printerNames={printerNames}
        printerNamesLoading={printerNamesLoading}
        printerData={printer}
        onPrinterDelete={onDelete}
      />
    </>
  );
};

export default PrinterRow;
